export const COMPANY_NAME = "Solar Energy Flow" as const;
export const COMPANY_PHONE = "+1 (630) 800-8077" as const;
export const COMPANY_EMAIL = "info@solarenergyflow.net" as const;
export const COMPANY_HOURS = "Mon - Fri: 9:00am - 5:00pm" as const;
export const COMPANY_PHONE_DISPLAY = "+1 (218) 460 - 9057";
export const COMPANY_PHONE_LINK = "+12184609057"; // For tel: links (no spaces, no symbols)


export const CompanyConfig = {
  COMPANY_NAME,
  COMPANY_PHONE_DISPLAY,
  COMPANY_EMAIL,
  COMPANY_HOURS,
  COMPANY_PHONE_LINK,
} as const;

export const COMPANY_ADDRESS = `123 Solar St.
Elk River, MN, 55330
United States`;

export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/SolarEnergyFlow",
  twitter: "https://twitter.com/SolarEnergyFlow",
  instagram: "https://instagram.com/SolarEnergyFlow",
  linkedin: "https://linkedin.com/company/solarenergyflow",
};
